import { FC } from "react";
import Spinner from "react-bootstrap/Spinner";

export const LoadingSpinner: FC = () => <Spinner animation="grow" variant="primary" />;
